import vIcon from './v-icon/index.vue';
import vItemTitle from './v-item-title/index.vue';
import vSwitch from './v-switch/index.vue';
import vNoData from './v-no-data/index.vue';
import vLoading from './v-loading/index.vue';
import vSuccessModal from './v-success-modal/index.vue';
import vFormatInput from './v-format-input/index.vue';

const components = {
  vIcon,
  vItemTitle,
  vSwitch,
  vNoData,
  vLoading,
  vSuccessModal,
  vFormatInput,
};

const install = (Vue) => {
  if (install.installed) return;
  Object.keys(components).forEach((key) => {
    Vue.component(key, components[key]);
  });
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

const CommonComponents = {
  install,
  ...components,
};

export default CommonComponents;
